@if (loadingCapture && !(detailsTable.length > 0)) {
  <div class="no-data">Loading capture…</div>
}
@if (!loadingCapture && !(dataTree.length > 0) && !(detailsTable.length > 0)) {
  <div>
    <div style="padding: 2rem">
      @if (isClientOnly) {
        <h1 class="open-title">Open a capture</h1>
      }
      @if (isClientOnly) {
        <p class="open-copy">
          WebShark runs in your browser. Drop a .pcap or .pcapng from your computer — nothing is uploaded.
        </p>
      }
      <div
        style="min-width: 200px; margin-bottom: 1rem"
        [style.height]="isKIOSK || isClientOnly ? '40vh' : '100px'"
        >
        <pcap-uploader></pcap-uploader>
      </div>
      @if (!isKIOSK && !isClientOnly) {
        <mat-list>
          <h1 mat-subheader>Files</h1>
          @for (note of fileList; track note) {
            <div
              class="list-item-hover"
              (click)="onClickFile(note.name)"
              >
              <mat-list-item>
                <mat-divider></mat-divider>
                <div style="height: 5px"></div>
                <mat-icon
                  mat-list-icon
                  color="primary"
            style="
              float: left;
              margin: 0px 12px;
              font-size: 40px;
              width: 40px;
              height: 40px;
            "
                  >note</mat-icon
                  >
                  <div mat-line>
                    <strong>{{ note.name }}</strong>
                  </div>
                  <div mat-line>{{ note.size }} bytes</div>
                </mat-list-item>
              </div>
            }
          </mat-list>
        }
      </div>
    </div>
  }
  <div class="flex-container">
    @if (!(!(dataTree.length > 0) && !(detailsTable.length > 0))) {
      <isData
        [noDataIf]="!(dataTree.length > 0) && !(detailsTable.length > 0)"
        >
        <div
      style="
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
        min-height: 0;
        min-width: 0;
        flex: 1;
      "
          >
          <app-menu-stat [liveFollowing]="liveFollowing"></app-menu-stat>
          <as-split [direction]="framePosition[0]" [gutterSize]="5">
            <as-split-area [size]="50">
              <div #tableDiv class="packet-list-host">
                <input
                  matInput
                  class="field-sticky"
                  style="padding: 1rem"
                  type="text"
                  autocomplete="off"
                  placeholder="Apply a display filter"
                  [(ngModel)]="textFilterGrid"
                  [matAutocomplete]="filterAuto"
                  (ngModelChange)="onFilterInput($event)"
                  (keydown.enter)="onFilterEnter()"
                  />
                <mat-autocomplete #filterAuto="matAutocomplete" (optionSelected)="setFilter($event.option.value)">
                  @for (choice of filterChoices; track choice) {
                    <mat-option [value]="choice">{{ choice }}</mat-option>
                  }
                </mat-autocomplete>
                <app-custom-table
                  [details]="filterGrid(detailsTable)"
                  [columns]="columnsTable"
                  [isSelectedByClick]="true"
                  [isPaginator]="false"
                  (rowClick)="showMessage($event)"
                  (rowDblClick)="openDetails($event)"
                  class="packet-list-table"
                  #dataGridTable
                ></app-custom-table>
              </div>
            </as-split-area>
            <as-split-area [size]="50">
              <as-split [direction]="framePosition[1]" [gutterSize]="5">
                <as-split-area [size]="50">
                  @if (dataTree && dataTree.length > 0) {
                    <tree-filter
                      [data]="dataTree"
                      style="flex: 1; overflow: auto"
                      (clickRow)="onSelected($event)"
                      [isFilter]="true"
                      [selectedHexArray]="selectedHexArray"
                      (filter)="setFilter($event)"
                    ></tree-filter>
                  }
                  @if (!dataTree || (dataTree && dataTree.length === 0)) {
                    <h1
                      class="no-data"
                      >
                      No Data
                    </h1>
                  }
                </as-split-area>
                <as-split-area [size]="50">
                  <app-frame-hex
                    [b64data]="frameHexDataBase64"
                    (onSelectedHex)="onSelectedHex($event)"
                    style="flex: 1"
                  ></app-frame-hex>
                </as-split-area>
              </as-split>
            </as-split-area>
          </as-split>
        </div>
      </isData>
    }
  </div>
